module.exports = __webpack_public_path__ + "media/images/edelman-c99481e60371f8992bc16ac69c126004.jpg";